import { SVGProps } from 'react';

const DownloadIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 10.5L12 15.5M12 15.5L7 10.5M12 15.5L12 3.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M19 19.5H5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export default DownloadIcon;
